import styled from 'styled-components';
import device from 'utils/device'

export default styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  border: 2px solid ${window?.settings?.primary_color ?? '#1DBD6B'};
  border-radius: 30px;
  background-color: #FFFFFF;
  width: calc(100vw - 10px);
  height: calc(100% - 10px);
  position: relative;
  overflow-y: auto;

  @media ${device.laptop} {
    background-color: unset;
    background-color: ${p => p.background || '#FFF'};
    box-shadow: 0px 4px 40px rgba(160, 174, 192, 0.15);
    max-height: calc(100vh - 70px);
    max-width: calc(100vw - 100px);
    width: ${p => p.width ? p.width : '800px'};
    height: 100%;
    overflow-y: auto;
  }
`;